module.exports = __webpack_public_path__ + "media/excellusbcbs-wordpress-feed@lg-e6883df966f1b8cfa9abd5665d2e3847.jpg";